import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  /** Hover lift + accent ring (utile pour cards cliquables). */
  interactive?: boolean;
  /** Padding interne. */
  padded?: boolean;
};

export function Card({
  children,
  className = "",
  interactive = false,
  padded = true,
}: Props) {
  return (
    <div
      className={`rounded-2xl bg-white ring-1 ring-navy-100 shadow-sm ${
        padded ? "p-6" : ""
      } ${
        interactive
          ? "transition-all hover:ring-accent-300 hover:shadow-lg hover:shadow-accent-500/10 hover:-translate-y-0.5 cursor-pointer"
          : ""
      } ${className}`.trim()}
    >
      {children}
    </div>
  );
}
